module.exports = __webpack_public_path__ + "img/off.87c58671.png";